import { useState } from 'react';
import { Header } from './components/Header/Header';
import DistrictMap from './components/Map/DistrictMap';
import { Sidebar } from './components/Sidebar/Sidebar';
import { ConstituencyModal } from './components/Details/ConstituencyModal';
import type { Election, Constituency } from './lib/types';

function App() {
  const [selectedElection, setSelectedElection] = useState<Election | null>(null);
  const [selectedConstituency, setSelectedConstituency] = useState<Constituency | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProvince, setSelectedProvince] = useState<string | null>(null);
  const [selectedDistrict, setSelectedDistrict] = useState<string | null>(null);

  return (
    <div className="flex flex-col h-screen bg-background">
      <Header 
        selectedElection={selectedElection}
        onElectionChange={setSelectedElection}
      />
      
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          selectedProvince={selectedProvince}
          onProvinceChange={setSelectedProvince}
          selectedDistrict={selectedDistrict}
          onDistrictChange={setSelectedDistrict}
          onConstituencySelect={setSelectedConstituency}
        />
        
        <main className="flex-1 relative">
          <DistrictMap
            selectedElection={selectedElection}
            onDistrictClick={(districtId) => {
              console.log('District clicked:', districtId);
              setSelectedDistrict(districtId);
            }}
          />
        </main>
      </div>

      {selectedConstituency && (
        <ConstituencyModal
          constituency={selectedConstituency}
          selectedElection={selectedElection}
          onClose={() => setSelectedConstituency(null)}
        />
      )}
    </div>
  );
}

export default App;
